import React, { useContext, useMemo } from "react";
import { Link as GatsbyLink, navigate } from "gatsby";
import base64 from "react-native-base64";

import { generateClassString as gcs } from "../../lib/helper/generateClassString";
import isInternalLink from "../../lib/helper/isInternalLink";
import remoteAssetUrl from "../../lib/remote-asset-url";
import GeneralPageContext from "../../templates/GeneralPageContext";

const DEBUG = process.env.GATSBY_DEBUG_MODE === "TRUE";
const BASE_URL = process.env.GATSBY_BASE_URL;

export default function Link({
    children,
    to,
    masked,
    linkClass,
    activeClassName,
    partiallyActive,
    state,
    ...other
}) {
    const { currentSlug } = useContext(GeneralPageContext);
    const linkState = useMemo(
        () => ({
            ...state,
            prevUrl: `${BASE_URL.replace(/\/$/, "")}${currentSlug}`
        }),
        [currentSlug, state]
    );

    if (!to) {
        if (DEBUG) {
            console.warn("Link destination is not defined!");
        }
        return null;
    }

    const internal = isInternalLink(to);

    if (masked) {
        const encodedHref = base64.encode(to);

        return (
            <span
                className={gcs("link", linkClass)}
                data-href={encodedHref}
                onClick={navigateOnClick}
                onKeyDown={handleKeyDown}
                tabIndex="0"
                role="link"
            >
                {children}
            </span>
        );
    }

    if (internal) {
        return (
            <GatsbyLink
                to={to}
                className={gcs(linkClass)}
                activeClassName={activeClassName}
                partiallyActive={partiallyActive}
                state={linkState}
                {...other}
            >
                {children}
            </GatsbyLink>
        );
    }

    const options = other?.customdata ?? {};

    return (
        <a
            href={remoteAssetUrl(to, options)}
            className={gcs(linkClass)}
            {...other}
        >
            {children}
        </a>
    );
}

function handleKeyDown(event) {
    if (event.keyCode === 13) {
        navigateOnClick();
    }
}

function navigateOnClick(event) {
    const encodedHref = event.target.getAttribute("data-href");

    if (!encodedHref) return;

    const decodedHref = remoteAssetUrl(base64.decode(encodedHref));
    navigate(decodedHref);
}
